import deepExtend from './deepExtend.js';
import closestParent from './closestParent.js';

export default class ScrollToHandler {
    constructor(options = {}) {
        // const defaults = {
        //     // ...
        // };
        this.options = options; // deepExtend(defaults, options);

        document.addEventListener(
            'click',
            function (event) {
                let target = closestParent(
                    event.target,
                    'a[href^="#"]:not([href="#"]):not([data-w-noscrollto]), a[href^="' +
                        (window.location.origin + window.location.pathname) +
                        '"][href*="#"]:not([data-w-noscrollto])'
                );
                if (target) {
                    event.preventDefault();

                    const urlObject = document.createElement('a');
                    urlObject.href = target.href;

                    // parse hash if present + link and current url are the same
                    const selector =
                        urlObject.origin + urlObject.pathname ===
                        window.location.origin + window.location.pathname
                            ? urlObject.hash
                            : target.href;

                    // remove open menu in any case
                    document.documentElement.classList.remove(
                        'w-has-menu-open'
                    );
                    if (this.options.fixedMenu) this.options.fixedMenu.close();

                    const scrollTarget = document.querySelector(selector);
                    if (scrollTarget)
                        scrollTarget.scrollIntoView({
                            behavior: 'smooth',
                        });
                }
            }.bind(this),
            {
                passive: true
            }
        );
    }
}
